var exports = {
  "J": "SidePanelFooter__3VQqKQ",
};

module.exports = exports;
